import React__default from 'react';
import styles from './230f48bca895ae75ee29ab7b639ad5462876241d350c2037bfd6bdb365423a3e.cfe-internal.js';
import '../../icons/index.es.js';
import { newCondition, LOGIC_TYPE_SET, newConditionSet } from './05a657b89c4e3b2985613913e27c531d51aad8696a81c63eaa65a9959b1f6913.cfe-internal.js';
import '../NewMenu/e398fde241b408541f8b3bf9184b188b740154e1018a3d02682e36abb8784c79.cfe-internal.js';
import '../IconButton/fa92464f43077b1cbdd0bb416ee549d83eadaee9906eab0987bbf0ad889eddad.cfe-internal.js';
import { useLogicEditorContext } from './587a9c6736e7e443901f9bfa68401f276eb4b68d9d52fe6cf57f5f9d8d2114b6.cfe-internal.js';
import Menu from '../NewMenu/Menu/3929114ebae6d44e7787ca01ba85af7a317e46913e7154eb644023bcc7f616b7.cfe-internal.js';
import IconButton from '../IconButton/399631eebecc03da030561fb1a25c35c2d29c5e4645700b7fca3cf592ca75904.cfe-internal.js';
import EllipsisHorizontalIcon from '../../icons/components/6cff50c5b1055968e4d9caef3a8f2fe6fa611f63e408619999fa97bf8608a423.cfe-internal.js';
import MenuItem from '../NewMenu/parts/e0e3eb84541b87de3d5450a4a2a9274df211ed818d3168ab6e8a7aeb42987979.cfe-internal.js';
import AddItemIcon from '../../icons/components/a478121ec299540ff5626aeed12399822634a5433459258f73d9c9c4dda15626.cfe-internal.js';
import FilterIcon from '../../icons/components/6f8ae9e817215d0c89aab3af1b08489ca3c90047fe8458ee8df9b886fa146eff.cfe-internal.js';
import RemoveItemIcon from '../../icons/components/d956a238706715d15a89cb3d23c40abf79a9832c6fe1349595045724d63190a4.cfe-internal.js';

var Controls = function Controls(_ref) {
  var handleNewLogicItem = _ref.handleNewLogicItem,
    onDelete = _ref.onDelete,
    level = _ref.level,
    itemType = _ref.itemType,
    itemPosition = _ref.itemPosition,
    itemIndex = _ref.itemIndex,
    itemLevel = _ref.itemLevel,
    numberOfSetItems = _ref.numberOfSetItems,
    dataTestId = _ref['data-testid'];
  var _useLogicEditorContex = useLogicEditorContext(),
    translations = _useLogicEditorContex.translations,
    fixedSet = _useLogicEditorContex.fixedSet,
    defaultSetValue = _useLogicEditorContex.defaultSetValue,
    maxNestedSets = _useLogicEditorContex.maxNestedSets;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Menu, {
    anchor: /*#__PURE__*/React__default.createElement(IconButton, {
      "aria-label": translations.conditionActions,
      className: styles.controls,
      "data-testid": dataTestId
    }, /*#__PURE__*/React__default.createElement(EllipsisHorizontalIcon, null))
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    value: "add-condition",
    onSelect: handleNewLogicItem(newCondition(), itemType === LOGIC_TYPE_SET ? 0 : itemIndex)
  }, /*#__PURE__*/React__default.createElement(AddItemIcon, {
    "aria-hidden": "true"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: styles.controlMenuItem
  }, translations.insertConditionBelow)), !fixedSet && level < maxNestedSets && /*#__PURE__*/React__default.createElement(MenuItem, {
    value: "add-set",
    onSelect: handleNewLogicItem(newConditionSet(defaultSetValue), itemType === LOGIC_TYPE_SET ? 0 : itemIndex)
  }, /*#__PURE__*/React__default.createElement(FilterIcon, {
    "aria-hidden": "true"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: styles.controlMenuItem
  }, translations.insertSetBelow)), (fixedSet && numberOfSetItems > 1 || !fixedSet && itemLevel > 0) && /*#__PURE__*/React__default.createElement(MenuItem, {
    value: "delete",
    onSelect: function onSelect() {
      return onDelete(itemPosition);
    }
  }, /*#__PURE__*/React__default.createElement(RemoveItemIcon, {
    "aria-hidden": "true"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: styles.controlMenuItem
  }, translations["delete"]))));
};

export { Controls as default };
